import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import store from '../store';

const getUser = () => {
    const userStr = Cookies.get('ce_user');
    const key = Cookies.get('ce_provider');
    if (userStr && key) {
        const decodeStr = CryptoJS.AES.decrypt(userStr, key).toString(CryptoJS.enc.Utf8);
        if (decodeStr) {
            store.dispatch('user/setUser', JSON.parse(decodeStr));
        }
    }
};

const getToken = () => {
    const token = Cookies.get('ce_token');
    if (token) {
        store.dispatch('user/setToken', token).then(() => {
            const guid = Cookies.get('ce_guid');
            if (guid) {
                store.dispatch('user/setLocalGuid', guid);
            }
        });
    }
};

const getPronvince = () => {
    const province = sessionStorage.getItem('ce_cprovince');
    if (province) {
        store.dispatch('shop/setCurrentProvince', JSON.parse(province));
    }
};

export const initData = () => {
    getUser();
    getToken();
    getPronvince();
};
